<template>
  <div class="address-data mb-n4">
    <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
           no-gutters>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="strasse"
                      v-validate="{ required: true, regex: /^[^!§$%&\/()=?#*+{\[\]}]*$/ }"
                      v-dmb-trim
                      :error-messages="errors.collect('strasse')"
                      data-vv-as="Straße"
                      class="required"
                      name="strasse"
                      label="Straße" />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="hausnummer"
                      v-validate="{ required: true, regex: /^[1-9][0-9a-zA-Z-\/,]*$/ }"
                      v-dmb-trim
                      :error-messages="errors.collect('hausnummer')"
                      data-vv-as="Hausnummer"
                      class="required"
                      name="hausnummer"
                      label="Hausnummer"
                      @change="restrictHausnummer"
                       />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="plz"
                      v-validate="plzValidation"
                      v-dmb-trim
                      :error-messages="errors.collect('plz')"
                      data-vv-as="Postleitzahl"
                      class="required"
                      name="plz"
                      label="Postleitzahl"
                      @input="onInputPlz" />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-if="cityList.length === 0"
                      v-model="ort"
                      v-validate="{ required: true, regex: regex.ort }"
                      v-dmb-trim
                      :error-messages="errors.collect('ort')"
                      data-vv-as="Ort"
                      class="required"
                      name="ort"
                      label="Ort" />
        <v-combobox v-else
                    v-model="ort"
                    v-validate="{ required: true, regex: regex.ort }"
                    v-dmb-trim
                    :error-messages="errors.collect('ort')"
                    :items="cityList"
                    data-vv-as="Ort"
                    name="ort"
                    class="required"
                    label="Ort" />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-autocomplete v-model="staat"
                        v-validate="'required'"
                        :error-messages="errors.collect('land')"
                        :readonly="staatDisabled"
                        :disabled="staatDisabled"
                        :items="countryList"
                        data-vv-as="Land"
                        name="land"
                        label="Land"
                        class="required" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import countries from "@/store/config/countries";
import ValidationMixin from "@/components/helper/ValidationMixin";
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import REGEX from "@/validation/regexes";

export default {
  mixins: [ValidationMixin, twowayBinding, plzOrtMixin],
  props: {
    staatDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      countryList: countries.europeanCountryList,
      regex: REGEX
    };
  },
  computed: {
    ...mapTwoWay([
      "strasse",
      "hausnummer",
      "ort",
      "plz",
      "staat",
      "key"
    ]),
    plzValidation() {
      const validations = {
        required: true
      };
      if (this.staatDisabled) {
        validations.regex = /^[0-9]{5} ?$/;
      }
      return validations;
    }
  },
  methods: {
    restrictHausnummer() {
      this.hausnummer = this.hausnummer.replace(/[^0-9a-zA-Z-/,]/g, ""); //on blur change
    }
  }
};
</script>

<style>
  .v-list-item {
    min-height: 36px !important; /* overwrite vuetify from 48px */
  }
  .v-list-item__content{
    padding-bottom: 8px;  /* overwrite vuetify from 12px */
    padding-top: 8px;
  }
</style>

